// extracted by mini-css-extract-plugin
module.exports = {"container":"manage_container__1M_Vr","content":"manage_content__2QezG","heading":"manage_heading__atLOm","iconWrapper":"manage_iconWrapper__3IlCP","icon":"manage_icon__3SPrw"};